import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/api/client';

/** Server state for the whole app: React Query's cache, with the panel's retry rule. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // An unauthenticated or forbidden answer will not become a different answer
      // by asking again; retrying only delays telling the operator.
      retry: (failureCount, error) =>
        error instanceof ApiError && ['UNAUTHENTICATED', 'FORBIDDEN'].includes(error.code)
          ? false
          : failureCount < 2,
      refetchOnWindowFocus: true,
    },
  },
});
